'use client'

import { useEffect } from 'react'
import { reportClientError } from '@/lib/errorReporting'

// Only fires for errors thrown above app/error.tsx's reach (e.g. inside the root layout
// itself) — must render its own <html>/<body> since it replaces the whole tree on error.
export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    reportClientError({
      message: error.message,
      stack: error.stack,
      digest: error.digest,
      source: 'global-error',
    })
  }, [error])

  return (
    <html lang="en">
      <body>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', fontFamily: 'sans-serif', gap: '1rem', padding: '0 1.5rem', textAlign: 'center' }}>
          <h1 style={{ fontSize: '1.25rem', fontWeight: 600, margin: 0 }}>Something went wrong</h1>
          <p style={{ color: '#64748b', maxWidth: '24rem' }}>We've logged the issue. Try again.</p>
          <button
            onClick={() => reset()}
            style={{ padding: '0.5rem 1rem', borderRadius: '0.75rem', fontSize: '0.875rem', fontWeight: 600, color: 'white', background: 'rgb(79, 70, 229)', border: 'none', cursor: 'pointer' }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  )
}
